const INITIAL_STATE = {
    pageNo: 1,
    payerListing: []
  };
  
  export default function payerList(state = INITIAL_STATE, { type, payload }) {
    switch (type) {
      case 'data-load_FULFILLED': {
        if (payload && payload.key === 'payers1') {
          // console.log('payload************', payload);
          // console.log('props........>>>****', this.props);
          // const url_string = new URL(payload.response.config.url && payload.response.config.url);
  
          // const pageNo = url_string.searchParams.get("pageNo");
          return {
            // pageNo: pageNo,
            payerListing: [
            ...state.payerListing,
            ...payload.response.data
          ]
          };
        }
        return state;
      }
  
      case 'clearCustomerList': {
        // console.log('INITIAL_STATE2', state);
          return INITIAL_STATE;
        }
        
      default:
        return state;
    }
  }
  